<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Editar Especificações de Serviço</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
<!--  <div [formGroup]="form" class="flex justify-between gap-4 items-center mt-3">-->


    <div
      [formGroup]="form"
      class="py-2 px-6 items-center"
    >
      <div class="flex justify-between items-center -mx-2 gap-4">
    <mat-form-field
      class="input-tg mt-message-input w-2/12"
      appearance="outline"
    >
      <mat-label>Código</mat-label>
      <input matInput formControlName="code" />
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-3/12"
      appearance="outline"
    >
      <mat-label>Tipo Serviço</mat-label>
      <mat-select formControlName="typeService">
        @for (type of listType; track type) {
          <mat-option [value]="type.id">{{ type.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field
      class="input-tg mt-message-input w-7/12"
      appearance="outline"
    >
      <mat-label>Descrição</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
  </div>

      <div class="flex justify-start items-center -mx-2 gap-4">

    <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
      <mat-label>Carga horária</mat-label>
      @if (form.get('hour')!.value != '') {
        <span matTextSuffix>Hora(s)</span>
      }
      <input matInput integerInput formControlName="hour" />
    </mat-form-field>
    <mat-form-field class="input-tg mt-message-input w-3/12" appearance="outline">
      <mat-label>Quilometragem</mat-label>
      @if (form.get('km')!.value != '') {
        <span matTextSuffix>Km</span>
      }
      <input matInput currencyInput formControlName="km" />
    </mat-form-field>
    <mat-slide-toggle
      class="input-tg mt-message-input w-3/12 p-bottom-toggle"
      formControlName="vehicle"
    >
      Exige veículo
      <u>{{ form.get('vehicle')?.value ? 'sim' : 'não' }}</u></mat-slide-toggle
    >
  </div>
  </div>
  <div class="flex justify-end">
    <button
      mat-flat-button
      class="btn-tg w-2/12"
      [disabled]="form.invalid || loading"
      (click)="updateItem()"
    >
      @if (loading) {
        <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
      } @else {
        Salvar
      }
    </button>
  </div>
</mat-card>
